import { render, staticRenderFns } from "./templateReport.vue?vue&type=template&id=6c3c47bc&scoped=true&"
import script from "./templateReport.vue?vue&type=script&lang=js&"
export * from "./templateReport.vue?vue&type=script&lang=js&"
import style0 from "./templateReport.vue?vue&type=style&index=0&id=6c3c47bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3c47bc",
  null
  
)

export default component.exports